import { useMutation, useQuery, useQueryClient, requestDeals } from '@workspace/api';

export interface TaskTimings {
    direct_demande_devis: number;
    direct_devis_orange: number;
    comparateur_demande_devis: number;
    comparateur_devis_orange: number;
    comparateur_rappel: number;
    comparateur_souscrire: number;
    lsa_rva_demande_devis: number;
}

export function useTaskTimings() {
    return useQuery<{ data: TaskTimings }>({
        queryKey: ['deals', 'settings', 'task-timings'],
        queryFn: async () => {
            const response = await requestDeals.get<{ data: TaskTimings }>('/api/settings/task-timings');
            return response.data;
        },
        staleTime: 60 * 1000,
    });
}

export function useUpdateTaskTimings() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (timings: TaskTimings) => {
            const response = await requestDeals.put<{ data: TaskTimings; message: string }>(
                '/api/settings/task-timings',
                timings,
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['deals', 'settings', 'task-timings'] });
        },
    });
}
